import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"link-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11.2934 18.3638L9.87923 19.778C8.12187 21.5354 5.27259 21.5353 3.51527 19.778C1.75795 18.0207 1.75791 15.1714 3.51527 13.414L6.69725 10.2321C8.45461 8.47471 11.3039 8.47475 13.0612 10.2321L13.65 10.8208M12.7075 5.63652L14.1217 4.2223C15.879 2.46494 18.7283 2.46498 20.4856 4.2223C22.243 5.97963 22.243 8.8289 20.4856 10.5863L17.3037 13.7682C15.5463 15.5256 12.697 15.5256 10.9397 13.7682L10.1143 12.9428","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Link1 = Vue.extend<IconProps>({
  name: 'Link1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'link-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Link1;
